import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import Modal from '../Elements/Modal';
import { Loader } from 'lucide-react';
import axios from "axios";
import Cookies from "js-cookie";

const RatingsPage = ({ 
  currentPage,
  setCurrentPage,
  setTitleDescription,
  openCompanyPage,
  authStatus
}) => {
  
  useEffect(() => {
    setTitleDescription("Fractofolio - Ratings", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  const [loading, setLoading] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("United States");
  const [error, setError] = useState("");
  const [createReportStatus, setCreateReportStatus] = useState(false);
  const [createReportDuplicateStatus, setCreateReportDuplicateStatus] = useState(false);
  const [isModalReport, setIsModalReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState({
    id: 0,
    country: "",
    sector: "",
    industry: "",
    undervalued_companies: [],
    overvalued_companies: [],
    created_at: 0,
    completed_at: 0,
    companies: 0,
    undervalued: 0,
    overvalued: 0
  });
  
  
  const [totalPages, setTotalPages] = useState(20);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [loadingCreateReport, setLoadingCreateReport] = useState(false);
  

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
  };

  // Function to handle Next button click
  const nextPage = () => {
    if (currentPageNumber < totalPages) {
      setCurrentPageNumber(currentPageNumber + 1);
    }
  };

  // Function to handle Previous button click
  const prevPage = () => {
    if (currentPageNumber > 1) {
      setCurrentPageNumber(currentPageNumber - 1);
    }
  };

  // Determine which page numbers to show (max 5 page numbers)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const start = Math.max(currentPageNumber - 2, 1); // Start page number (current page - 2)
    const end = Math.min(start + 4, totalPages); // End page number (start + 4)

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };




  const [text, setText] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchResults, setsearchResults] = useState([]);
  const canShowSearchRef = useRef(true);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [ratingResults, setRatingResults] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const loadingIndustriesRef = useRef(false);
  
  


  // Assuming you're inside a component
  const getReportList = useCallback(async() => {
    console.log("getReportList RUN");
    setLoading(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/over-under-reports/get-report-list`, { token: Cookies.get('token'), page: currentPageNumber });
      if(response.data.status == 'ok') {
        // setRatingResults(prev => {
        //   // Создаем мапу уже существующих id для быстрой проверки
        //   const existingIds = new Set(prev.map(item => item.id));

        //   // Фильтруем новые элементы, исключая те, id которых уже есть
        //   const filteredNewItems = response.data.result.filter(item => !existingIds.has(item.id));

        //   // Возвращаем объединенный массив без дубликатов
        //   return [...prev, ...filteredNewItems];
        // });

        setRatingResults(response.data.result)

        setTotalPages(response.data.max_page);

        // 🔁 Если есть хотя бы один результат с `completed_at === null`, запланировать повтор
        const hasIncomplete = response.data.result.some(
          (item) => item.completed_at === null
        );

        if (hasIncomplete) {
          setTimeout(() => {
            getReportList(); // повторный вызов
          }, 10000); // 30 секунд
        }
        
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPageNumber, selectedIndustry, selectedSector]);

  const getCointryList = useCallback(async() => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-country-list`, { });
      if(response.data.status == 'ok') {
        setCountryList(response.data.country_list);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      // setLoadingSearch(false);
    }
  }, []);

  const getSectors = useCallback(async() => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-sectors`, { });
      if(response.data.status == 'ok') {
        setSectors(response.data.sectors);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      // setLoadingSearch(false);
    }
  }, []);

  const getIndustries = useCallback(async() => {
    loadingIndustriesRef.current = true;
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-industries`, { sector: selectedSector });
      if(response.data.status == 'ok') {
        setIndustries(response.data.industries);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      loadingIndustriesRef.current = false;
    }
  }, [selectedSector]);

  async function generateReport() {
    if(authStatus === false) {
      setCurrentPage('auth/login');
      return "";
    }

    if(selectedSector == "") {
      setError("Please select a Sector");
      return ""
    }

    if(selectedIndustry == "") {
      setError("Please select a Industry");
      return ""
    }

    setLoadingCreateReport(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/over-under-reports/create-report`, { token: Cookies.get('token'), country: selectedCountry, sector: selectedSector, industry: selectedIndustry });
      if(response.data.status == 'ok') {
        if(response.data.new_report == true) {
          setCreateReportStatus(true);
          setLoadingCreateReport(false);
          await getReportList();
          await delay(3000);
          setCreateReportStatus(false);
        } else {
          setCreateReportDuplicateStatus(true);
          setLoadingCreateReport(false);
          await delay(3000);
          setCreateReportDuplicateStatus(false);
        }
        
      } else {
        setError(response.data.error);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoadingCreateReport(false);
    }

  }

  const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  useEffect(() => {
    getReportList();
    getSectors();
    getCointryList();
  }, [getReportList, getSectors]);

  useEffect(() => {
    getReportList();
    getIndustries();
  }, [currentPageNumber, selectedSector, selectedIndustry, getReportList, getIndustries]);

  function convertTimestampToYmdHisUTC(timestamp) {
    // Convert timestamp to Date object
    let date = new Date(timestamp * 1000);

    // Define options for formatting the date
    let options = { 
      month: 'long',         // "July"
      day: 'numeric',        // "3"
      year: 'numeric',       // "2025"
      hour: 'numeric',       // "11"
      minute: '2-digit',     // "25"
      hour12: true,          // Use AM/PM format
      // timeZone: 'UTC'
    };

    // Format the date
    let formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">

      <Modal isOpen={isModalReport} onClose={() => setIsModalReport(false)}>
        <h2 className="linkedin-title">Report: {selectedReport.country} - {selectedReport.sector} - {selectedReport.industry}</h2>
        <p className="linkedin-body-text mb-4">This report is current as of {convertTimestampToYmdHisUTC(selectedReport.completed_at)}. If you want the most up-to-date report, please create a new one.</p>

        {selectedReport.undervalued_companies.map((item, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 my-2 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div onClick={() => openCompanyPage(item, true)}>
                <h3 className="font-bold text-lg text-gray-900 cursor-pointer">{item.company_name}</h3>
              </div>
              <div className="text-xs bg-green-100 py-1 px-2 font-medium rounded">
                Undervalued
              </div>
            </div>
          </div>
        ))}

        {selectedReport.overvalued_companies.map((item, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 my-2 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div onClick={() => openCompanyPage(item, true)}>
                <h3 className="font-bold text-lg text-gray-900">{item.company_name}</h3>
              </div>
              <div className="text-xs bg-red-100 py-1 px-2 font-medium rounded">
                Overvalued
              </div>
            </div>
          </div>
        ))}

        <button onClick={() => setIsModalReport(false)} className="linkedin-btn-primary w-full">
          Close
        </button>
      </Modal>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3">
            <div className="linkedin-card mb-6">
              <div className="linkedin-card-header">
                <h2 className="text-xl font-bold text-gray-900">Discover Undervalued & Overvalued Stocks – AI Insights</h2>
                <p className="text-gray-600">Receive reports on overvalued and undervalued companies by country, sector, and industry.</p>
              </div>
              
              <div className="linkedin-card-content">
                <div className="w-full">
                  <div className="w-full flex flex-col md:flex-row gap-4 mb-1 items-center">
                    <select 
                      value={selectedCountry}
                      onChange={(event) => {setCurrentPageNumber(1); setSelectedCountry(event.target.value); }}
                      className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-linkedin-blue"
                    >
                      {countryList && countryList.map((item, key) => (
                        <option key={`key_country_list_${key}`} value={item}>{item}</option>
                      ))}
                    </select>

                    <select 
                      value={selectedSector}
                      onChange={(event) => {setCurrentPageNumber(1); setSelectedSector(event.target.value); setIndustries([]); setSelectedIndustry(""); setError(""); }}
                      className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-linkedin-blue"
                    >
                      <option value="">Select Sector</option>
                      {sectors && sectors.map((item, key) => (
                        <option key={`key_sector_${key}`} value={item}>{item}</option>
                      ))}
                    </select>

                    {loadingIndustriesRef.current === true && (
                      <div><Loader className="animate-spin text-black w-4 h-4" /></div>
                    )}

                    {selectedSector != "" && industries.length > 0 && (
                      <select
                        value={selectedIndustry}
                        onChange={(event) => {setCurrentPageNumber(1); setSelectedIndustry(event.target.value); setError(""); }}
                        className="border p-2 rounded-md"
                      >
                        <option value="">Select Industry</option>
                        {industries && industries.map((item, key) => (
                          <option key={`key_industry_${key}`} value={item}>{item}</option>
                        ))}
                      </select>
                    )}
                  </div>

                  <button onClick={() => generateReport() } disabled={loadingCreateReport} className="mt-1 bg-linkedin-blue text-white font-medium py-2 px-4 rounded-lg hover:bg-linkedin-blue-dark transition-colors">
                    {loadingCreateReport === false && (
                      <span>Generate Report</span>
                    )}
                    {loadingCreateReport === true && (
                      <span>Loading...</span>
                    )}
                  </button>

                  {createReportStatus == true && (
                    <div className="mt-2 w-full bg-green-100 rounded-md p-3">
                      <p className="text-sm font-main-medium text-black">The report has been created.</p>
                    </div>
                  )}

                  {createReportDuplicateStatus == true && (
                    <div className="mt-2 w-full bg-yellow-100 rounded-md p-3">
                      <p className="text-sm font-main-medium text-black">The report for this country, sector, and industry has already been created today.</p>
                    </div>
                  )}

                  {error != "" && (
                    <div className="mt-2 w-full bg-red-100 rounded-md p-3">
                      <p className="text-sm font-main-medium text-black">{error}</p>
                    </div>
                  )}

                </div>

              </div>
            </div>

            <div className="linkedin-card mb-6">
              <div className="linkedin-card-header">
                <h2 className="text-xl font-bold text-gray-900">Generated Reports</h2>
                <p className="text-gray-600">The list of generated reports</p>
              </div>
              
              <div className="linkedin-card-content">
                <div className="space-y-4">

                  {authStatus === true && loading == false && ratingResults.length == 0 && (
                    <div>
                      <p className="text-lg text-center font-bold">You don't have any reports</p>
                      <p className="text-sm text-center font-regular">Generate new reports using AI-powered insights</p>
                    </div>
                  )}

                  {authStatus === false && loading == false && ratingResults.length == 0 && (
                    <div className="w-full flex flex-col p-4 w-[100%]">
                      <div className="bg-white rounded-lg p-4">
                        <p className="text-lg text-center font-bold">Log in to your account to access AI Analysis</p>
                        <p className="text-sm text-center font-regular">Create one for free on Fractofolio to unlock AI-powered insights.</p>
                        <div className="mx-auto w-fit mt-3">
                          <button 
                            onClick={() => setCurrentPage('auth/signup')}
                            className="linkedin-btn-primary text-sm px-4 py-1.5"
                          >
                            Join now
                          </button>
                        </div>
                        <div className="mx-auto w-fit mt-1">
                          <span onClick={() => setCurrentPage('auth/login')} className="text-sm text-center font-regular underline cursor-pointer">Log in</span>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                    {ratingResults.map((item, index) => (
                      <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center justify-between">
                            <div className="">
                              <h3 className="font-bold text-lg text-gray-900">{item.country}<br/>{item.sector}<br/>{item.industry}</h3>
                            </div>
                          </div>
                        </div>
                        
                        <div className="space-y-2">
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Companies:</span>
                            <span className="font-medium">
                              {item.completed_at == null && (
                                <div className="animate-spin text-gray-500"><Loader size={14} /></div>
                              )}
                              {item.completed_at != null && (
                                <>{item.companies}</>
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Undervalued:</span>
                            <span className="font-medium">
                              {item.completed_at == null && (
                                <div className="animate-spin text-gray-500"><Loader size={14} /></div>
                              )}
                              {item.completed_at != null && (
                                <>{item.undervalued}</>
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Overvalued:</span>
                            <span className="font-medium">
                              {item.completed_at == null && (
                                <div className="animate-spin text-gray-500"><Loader size={14} /></div>
                              )}
                              {item.completed_at != null && (
                                <>{item.overvalued}</>
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Report Date:</span>
                            <span className="font-medium">{convertTimestampToYmdHisUTC(item.created_at)}</span>
                          </div>
                        </div>
                        
                        <button onClick={() => { setSelectedReport(item); setIsModalReport(true); }} disabled={item.completed_at == null ? true : false} className="w-full mt-4 bg-linkedin-blue text-white py-2 px-4 rounded-lg hover:bg-linkedin-blue-dark transition-colors flex justify-center items-center"  >
                          {item.completed_at == null && (
                            <><Loader className="animate-spin mr-2 w-4 h-4" />Generating...</>
                          )}
                          {item.completed_at != null && (
                            <>View Details</>
                          )}
                        </button>

                        {item.completed_at == null && (
                          <p className="text-center text-xs mt-2">Usually, it takes up to 5 minutes.</p>
                        )}

                      </div>
                    ))}
                  </div>
                </div>

                {/* <div className='mt-2 mx-auto w-fit'>
                  <button onClick={() => {setCurrentPageNumber(currentPageNumber+1)}} className="linkedin-action-btn" disabled={loading}>
                    {loading === false && (
                      <span>Load more companies</span>
                    )}
                    {loading === true && (
                      <span>Loading...</span>
                    )}
                  </button>
                </div> */}
                
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingsPage;